'use client'
import { useState, useRef } from 'react'
import Image from 'next/image'

import { Media as MediaType } from '@/payload-types'

interface IProps {
  videoData: MediaType
  embeddedVideo?: boolean
  timeStamp?: string | null
  isSmall?: boolean
}

export const VideoComponent = ({
  videoData,
  embeddedVideo = false,
  timeStamp,
  isSmall = false,
}: IProps) => {
  const [playVideoBg, setPlayVideoBg] = useState(false)

  const [play, setPlay] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)
  const bgVideoRef = useRef<HTMLVideoElement>(null)

  const handlePlayClick = () => {
    if (videoRef.current && bgVideoRef.current) {
      if (!play) {
        if (videoRef.current.currentTime === 0) {
          const startTime = Number(timeStamp) - 1
          videoRef.current.currentTime = startTime ? startTime : 0
          bgVideoRef.current.currentTime = startTime ? startTime : 0
        }
        videoRef.current.play()
        bgVideoRef.current.play()
      } else {
        videoRef.current.pause()
        bgVideoRef.current.pause()
      }
      setPlay(!play)
    }
  }

  const handleVideoEvents = () => {
    if (videoRef.current && bgVideoRef.current) {
      if (videoRef.current.paused) {
        bgVideoRef.current.pause()
      } else {
        bgVideoRef.current.play()
      }
      bgVideoRef.current.currentTime = videoRef.current.currentTime
    }
  }

  const coverImage = ` ${
    embeddedVideo
      ? videoData.coverImage
      : process.env.NEXT_PUBLIC_PAYLOAD_URL
      ? process.env.NEXT_PUBLIC_PAYLOAD_URL
      : ''
  }${typeof videoData.coverImage === 'object' ? videoData.coverImage?.sizes?.medium?.url : ''}`

  return (
    <div className="relative h-full">
      <div className="absolute inset-0 overflow-hidden !rounded-lg">
        <video
          ref={bgVideoRef}
          className="absolute w-full h-full object-cover scale-110 blur-md !rounded-lg"
          muted
          playsInline
          src={`${
            embeddedVideo
              ? ''
              : process.env.NEXT_PUBLIC_PAYLOAD_URL
              ? process.env.NEXT_PUBLIC_PAYLOAD_URL
              : ''
          }${videoData.url}`}
        />
        <div
          className="absolute inset-0"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backgroundBlendMode: 'overlay',
          }}
        />
      </div>
      <video
        ref={videoRef}
        className="relative !rounded-lg w-full h-full"
        poster={coverImage}
        preload="none"
        controls={play}
        onPlay={handleVideoEvents}
        onPause={handleVideoEvents}
        onSeeked={handleVideoEvents}
      >
        <source
          src={`${
            embeddedVideo
              ? ''
              : process.env.NEXT_PUBLIC_PAYLOAD_URL
              ? process.env.NEXT_PUBLIC_PAYLOAD_URL
              : ''
          }${videoData.url}`}
          type="video/mp4"
        />
        <track
          src={`${
            embeddedVideo
              ? ''
              : process.env.NEXT_PUBLIC_PAYLOAD_URL
              ? process.env.NEXT_PUBLIC_PAYLOAD_URL
              : ''
          }${videoData.url}`}
          kind="subtitles"
          srcLang="en"
          label="English"
        />
      </video>
      {!play && (
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            className="relative flex items-center justify-center"
            onClick={handlePlayClick}
            onMouseEnter={() => setPlayVideoBg(true)}
            onMouseLeave={() => setPlayVideoBg(false)}
          >
            <div
              className={`
                rounded-full border-[3px] border-cm-red bg-black bg-opacity-55 
                ${playVideoBg ?? 'bg-white bg-opacity-20'}
                ${isSmall ? 'w-10 h-10' : 'w-20 h-20'}
                `}
            ></div>
             <Image
              className={`absolute ${isSmall ? 'left-3' : 'left-6'}`}
              src={'/images/favicons/play icon.svg'}
              alt={'Button Image'}
              width={isSmall ? 20 : 40}
              height={isSmall ? 20 : 40}
            />
          </button>
        </div>
      )}
    </div>
  )
}

export default VideoComponent
